"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.MACHINE_TYPE_NAMES = void 0;
var UNKNOWN = 'n_a';
var NETZSCH_ALPHA_DISCUS = 'NETZSCH_ALPHA_DISCUS';
var NETZSCH_ALPHA_MACRO = 'NETZSCH_ALPHA_MACRO';
var NETZSCH_ALPHA_NEOS = 'NETZSCH_ALPHA_NEOS';
var NETZSCH_ALPHA_ZETA = 'NETZSCH_ALPHA_ZETA';
var NETZSCH_DISCUS_INTENSIVE = 'NETZSCH_DISCUS_INTENSIVE';
var NETZSCH_LAB_STAR = 'NETZSCH_LAB_STAR';
var NETZSCH_MASTER_REFINER = 'NETZSCH_MASTER_REFINER';
var NETZSCH_PUMP_GENERIC = 'NETZSCH_PUMP_GENERIC';
var MACHINE_TYPE_NAMES = exports.MACHINE_TYPE_NAMES = {
  UNKNOWN: UNKNOWN,
  NETZSCH_ALPHA_DISCUS: NETZSCH_ALPHA_DISCUS,
  NETZSCH_ALPHA_MACRO: NETZSCH_ALPHA_MACRO,
  NETZSCH_ALPHA_NEOS: NETZSCH_ALPHA_NEOS,
  NETZSCH_ALPHA_ZETA: NETZSCH_ALPHA_ZETA,
  NETZSCH_DISCUS_INTENSIVE: NETZSCH_DISCUS_INTENSIVE,
  NETZSCH_LAB_STAR: NETZSCH_LAB_STAR,
  NETZSCH_MASTER_REFINER: NETZSCH_MASTER_REFINER,
  NETZSCH_PUMP_GENERIC: NETZSCH_PUMP_GENERIC
};
var _default = exports["default"] = [{
  value: UNKNOWN,
  name: 'not implemented',
  type: 'unknown',
  brand: 'unknown'
}, {
  value: NETZSCH_ALPHA_DISCUS,
  type: 'Discus',
  name: 'Grinding System Discus Intensive',
  brand: 'Netzsch'
}, {
  value: NETZSCH_ALPHA_MACRO,
  type: 'Macro',
  name: 'Grinding System Discus Intensive',
  brand: 'Netzsch'
}, {
  value: NETZSCH_DISCUS_INTENSIVE,
  type: 'Discus Intensive',
  name: 'Grinding System Discus Intensive',
  brand: 'Netzsch'
}, {
  value: NETZSCH_LAB_STAR,
  type: 'LabStar',
  name: 'LabStar',
  brand: 'Netzsch'
}, {
  value: NETZSCH_MASTER_REFINER,
  type: 'MasterRefiner',
  name: 'Grinding System Discus Intensive',
  brand: 'Netzsch'
}, {
  value: NETZSCH_ALPHA_NEOS,
  type: 'Neos',
  name: 'Grinding System Discus Intensive',
  brand: 'Netzsch'
}, {
  value: NETZSCH_PUMP_GENERIC,
  type: 'Pump',
  name: 'Pump',
  brand: 'Netzsch'
}, {
  value: NETZSCH_ALPHA_ZETA,
  type: 'Zeta®',
  name: 'Grinding System Discus Intensive',
  brand: 'Netzsch'
}];